import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FCurrencyFieldMDP from "@/components/form/field/FCurrencyFieldMDP";
import FNumberFieldMDP from "@/components/form/field/FNumberFieldMDP";
import FRangeSliderMDP from "@/components/form/field/FRangeSliderMDP";


export default class TMOStimulatorFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  constructor({ taskRoot }: { taskRoot: any }) {
    super({
      myRefName: "tmoStimulatorFFormRef",
    });
    this.taskRoot = taskRoot;

    this.addField(
      new FCurrencyFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "outstanding",
        label: "Outstanding Amount",
        mandatory: true,
        boundaryClass: "col-4",
      })
    )
      .addField(
        new FNumberFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "settlementPercentage",
          label: "Settlement Percentage",
          boundaryClass: "col-4",
          
        })
      )
      .addField(
        new FCurrencyFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "affordability",
          label: "Affordability",
          boundaryClass: "col-4",
        })
      )
      // .addField(
      //   new FSelectDateFieldMDP({
      //     parentMDP: this.childMDP,
      //     dataSelectorKey: "firstSPADraftDate",
      //     label: "First SPA Draft Date",
      //     mandatory: true,
      //     boundaryClass: "col-3",
      //     pastDaysDisabled: true,
      //   })
      // )
      .
      addField(
        new FRangeSliderMDP({
          parentMDP: this.childMDP,
          mandatory: true,
          boundaryClass: "col-12",
          minValue:1,
          maxValue:72
        })
      );
  }

  getMyRef(): any {
    return this.taskRoot.$refs[this.myRefName];
  }
}
